import { useQuery } from '@apollo/client';

import { showErrorToast } from 'src/components/Toasts/toast';
import {
    GET_COMPLETED_MERCHANT_SERVICES,
    GET_IN_PROGRESS_MERCHANT_SERVICES,
} from 'src/graphql/queries/merchantServices.query';

export type MerchantServicesType = 'in progress' | 'completed';

const useMerchantServices = (type: MerchantServicesType) => {
    const query =
        type === 'completed' ? GET_COMPLETED_MERCHANT_SERVICES : GET_IN_PROGRESS_MERCHANT_SERVICES;

    const { loading, data } = useQuery(query, {
        onError: () => {
            showErrorToast(`Failed to fetch ${type} merchant services`);
        },
    });

    return {
        loading,
        services:
            type === 'completed'
                ? (data?.completedServices ?? [])
                : (data?.inProgressServices ?? []),
    };
};

export default useMerchantServices;
